/* Alpha Elements – Widerruf (/pages/widerruf): Online-Widerrufsfunktion „Vertrag widerrufen“ auf Shopifys Kontaktformular
   (sections/ae-widerruf-main.liquid). Prüft die Pflichtfelder, setzt die Widerrufserklärung als contact[body] zusammen und
   sendet dann ganz normal an Shopify. Die Zusammenfassung für die Erfolgsmeldung liegt nur kurz im sessionStorage dieses Tabs.
   Dazu: Scrollspy fürs Inhaltsverzeichnis (Auf-/Zuklappen auf dem Handy macht ae.js). */
(() => {
  'use strict';
  const KEY = 'ae-wf-receipt';
  const fmtDate = { day: 'numeric', month: 'long', year: 'numeric' };

  /* ---------- table of contents: mark the current section ---------- */
  const toc = document.querySelector('.legal [data-toc]');
  if (toc && 'IntersectionObserver' in window) {
    const links = [...toc.querySelectorAll('a[href^="#"]')];
    const mark = id => links.forEach(a => (a.getAttribute('href') === '#' + id ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current')));
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) mark(e.target.id); }), { rootMargin: '-15% 0px -70% 0px' });
    links.forEach(a => { const s = document.getElementById(a.getAttribute('href').slice(1)); if (s) io.observe(s); });
  }

  const form = document.getElementById('wf-form');
  if (!form) return;
  const fields = document.getElementById('wf-fields');
  const done = document.getElementById('wf-done');
  const itemsWrap = document.getElementById('wf-items-wrap');
  const items = document.getElementById('wf-items');
  const body = document.getElementById('wf-body');

  const fieldOf = el => el.closest('.fld');
  const setErr = (el, ok) => {
    const f = fieldOf(el), err = f && f.querySelector('.err');
    if (!f) return;
    f.classList.toggle('is-invalid', !ok);
    if (ok) el.removeAttribute('aria-invalid'); else el.setAttribute('aria-invalid', 'true');
    if (err) err.textContent = ok ? '' : err.dataset.msg;
  };
  const EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/;
  const check = el => {
    let ok = el.checkValidity() && (!el.required || el.value.trim() !== '');
    if (ok && el.type === 'email') ok = EMAIL_RE.test(el.value.trim());
    setErr(el, ok); return ok;
  };
  const scopeInputs = [...form.querySelectorAll('input[type=radio][name="contact[Umfang]"]')];
  const isPart = () => !!scopeInputs.find(r => r.checked && r.hasAttribute('data-part'));

  form.addEventListener('change', e => {
    if (!scopeInputs.includes(e.target) || !items) return;
    const part = isPart();
    itemsWrap.hidden = !part; items.required = part; items.disabled = !part;
    if (part) items.focus(); else setErr(items, true);
  });
  form.querySelectorAll('.fld input:not([type=radio]):not([type=hidden]), .fld textarea').forEach(el => {
    el.addEventListener('blur', () => { if (el.value.trim()) check(el); });
    el.addEventListener('input', () => { if (el.getAttribute('aria-invalid')) check(el); });
  });

  form.addEventListener('submit', e => {
    const invalid = [...form.querySelectorAll('.fld [required]')].filter(el => !el.disabled && !check(el));
    if (invalid.length) { e.preventDefault(); invalid[0].focus(); return; }
    const v = n => (form.elements[n] && !form.elements[n].disabled ? String(form.elements[n].value || '').trim() : '');
    const now = new Date();
    const scope = isPart() ? 'Einzelne Artikel: ' + v('contact[Artikel]') : 'Die gesamte Bestellung';
    const received = v('contact[Ware erhalten am]');
    const rows = [
      ['Name', v('contact[name]')],
      ['E-Mail', v('contact[email]')],
      ['Bestellnummer', v('contact[Bestellnummer]')],
      ['Widerruf für', scope],
    ];
    if (received) rows.push(['Ware erhalten am', new Date(received + 'T12:00').toLocaleDateString('de-AT', fmtDate)]);
    if (v('contact[Nachricht]')) rows.push(['Nachricht', v('contact[Nachricht]')]);
    rows.push(['Abgesendet am', now.toLocaleDateString('de-AT', fmtDate) + ', ' + now.toLocaleTimeString('de-AT', { hour: '2-digit', minute: '2-digit' }) + ' Uhr']);
    if (body) {
      body.value = [
        'Widerrufserklärung (Online-Widerrufsfunktion „Vertrag widerrufen“)',
        '',
        'Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über den Kauf der folgenden Waren:',
        scope,
        '',
        ...rows.filter(([k]) => k !== 'Widerruf für').map(([k, val]) => `${k}: ${val}`),
      ].join('\n');
    }
    try { sessionStorage.setItem(KEY, JSON.stringify({ email: v('contact[email]'), rows })); } catch (_) { /* private mode */ }
    window.AE?.track?.('withdrawal_submit', { scope: isPart() ? 'teil' : 'alles' });
    form.querySelector('[type=submit]')?.setAttribute('aria-busy', 'true');
  });

  /* success screen (rendered by Liquid after Shopify accepted the message) */
  if (done) {
    let data = null;
    try { data = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (_) { data = null; }
    if (data && Array.isArray(data.rows)) {
      const dl = document.getElementById('wf-receipt');
      data.rows.forEach(([k, val]) => { const dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = k; dd.textContent = val; dl.append(dt, dd); });
      document.getElementById('wf-mail').textContent = data.email || '';
      document.getElementById('wf-done-plain').hidden = true;
      document.getElementById('wf-done-detail').hidden = false;
      dl.hidden = false;
    }
    if (fields) fields.hidden = true;
    done.querySelector('h3')?.focus({ preventScroll: true });
  }
})();
